import React from 'react';
import ReactDOM from 'react-dom';

// internal
import App from '@app/app';
// import reportWebVitals from './reportWebVitals'

// style
import 'swiper/swiper.min.css';
import 'swiper/components/navigation/navigation.min.css';
import '@app/assets/styles/css/index.css';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
